import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import TagPill from "@/components/base/TagPill";
import { compareItems } from "@/mocks/compareData";

export default function CompareSection() {
  const featured = compareItems.slice(0, 3);

  return (
    <section className="border-y border-background-200/80 bg-background-100 py-16 md:py-20">
      <Container>
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="CROSSOVER"
            title="跨界对比：同一个场域里的两种身份"
            description="主播与演员、代言人与品牌挚友、常驻与飞行——同一空间里的位置关系，往往比人气本身更值得拆解。"
          />
          <Link
            to="/compare"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            进入对比榜单
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {featured.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <Link to={`/compare/${item.id}`} className="block h-52 w-full overflow-hidden">
                <img
                  src={item.coverImage}
                  alt={`${item.title}对比示意图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </Link>
              <div className="flex flex-1 flex-col p-5">
                <TagPill variant="primary">{item.category}</TagPill>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">
                  <Link to={`/compare/${item.id}`} className="transition-colors hover:text-primary-700">
                    {item.title}
                  </Link>
                </h3>
                <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                      <i className="ri-fire-line text-base" />
                    </span>
                    热度 {item.heat.toLocaleString()}
                  </span>
                  <Link
                    to={`/compare/${item.id}`}
                    className="inline-flex items-center gap-1 whitespace-nowrap font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    看维度对比
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-s-line text-sm" />
                    </span>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}